import { EventAuth } from '../event-store/event-auth.js';
import { sha256 } from './sha256.js';
import { RuntimeEnv } from '../environment/runtime-env.js';

export function getAuthId(env: RuntimeEnv, auth: EventAuth): Promise<string> {
  return sha256(env, `${auth.iss}:${auth.aud}:${auth.sub}`);
}
